import {
  Tabs as MantineTabs,
  TabsProps as MantineTabsProps,
} from '@mantine/core';

import styles from './Tabs.module.css';

export type TabsProps = Omit<
  MantineTabsProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style' | 'radius'
>;

const classNames = {
  root: styles.root,
  list: styles.list,
  tab: styles.tab,
  tabLabel: styles.tabLabel,
  tabSection: styles.tabSection,
  panel: styles.panel,
};

export function Tabs({ children, ...props }: TabsProps) {
  return (
    <MantineTabs unstyled classNames={classNames} {...props}>
      {children}
    </MantineTabs>
  );
}

Tabs.displayName = 'Tabs';
Tabs.List = MantineTabs.List;
Tabs.Tab = MantineTabs.Tab;
Tabs.Panel = MantineTabs.Panel;
